export const locality = org => {
  let locality = [];
  if (org?.location) {
    if (org.location?.locality) {
      locality.push(org.location.locality);
    }
    if (org.location?.administrativeArea) {
      locality.push(org.location.administrativeArea);
    }
    if (org.location?.country) {
      locality.push(org.location.country);
    }
  }

  return locality.join(", ");
};
